import { render, staticRenderFns } from "./DiscordMessageEmbed.vue?vue&type=template&id=208b57d0&scoped=true&"
import script from "./DiscordMessageEmbed.vue?vue&type=script&lang=js&"
export * from "./DiscordMessageEmbed.vue?vue&type=script&lang=js&"
import style0 from "./DiscordMessageEmbed.vue?vue&type=style&index=0&id=208b57d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "208b57d0",
  null
  
)

export default component.exports